import PropTypes from 'prop-types';
import React from 'react';
import { Link } from 'react-router-dom';
import styles from './NavItemSubMenu.module.css';

// eslint-disable-next-line react/prop-types
export default function NavItemSubMenu({ path, label, disabled = false }) {
  return (
    <li style={{ height: '100%' }}>
      { disabled ? (
        <p className={`${styles.navLinkSubMenu} ${styles.disabled}`}>
          {label}
        </p>
      ) : (
        <Link
          className={styles.navLinkSubMenu}
          to={path}
        >
          {label}
        </Link>
      )}
    </li>
  );
}

NavItemSubMenu.propTypes = {
  path: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  // eslint-disable-next-line react/forbid-prop-types
//   Logo: PropTypes.object.isRequired,
};
